import {BookingStatusTypes} from "app/bookingStatusTypes";

const NS = 'BookingsTypeFilter';

export default function BookingsTypeFilter() {
  "ngInject";

  return function (bookings) {

    function isBooked(booking) {
      return (booking.status && booking.status.statusType !== BookingStatusTypes.Cancelled);
    }

    return bookings ? bookings.filter(b => isBooked(b)) : [];
  };
}
